import { render, staticRenderFns } from "./TabCarouselDialog.vue?vue&type=template&id=eea424f4&scoped=true&"
import script from "./TabCarouselDialog.vue?vue&type=script&lang=js&"
export * from "./TabCarouselDialog.vue?vue&type=script&lang=js&"
import style0 from "./TabCarouselDialog.vue?vue&type=style&index=0&id=eea424f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea424f4",
  null
  
)

export default component.exports